import React from 'react'

export const Permission = () => {
    return (
        <div className="system">
            <h2 className="system__title">You do not have permission to visit this page!</h2>
        </div>
    )
}